import React from "react";

export default function VendorleadsGradientText({ style = {}, children = "Vendorleads" }) {
  return (
    <span
      style={{
        background: "linear-gradient(90deg, #10b981, #3b82f6)",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        color: "transparent",
        fontWeight: 700,
        fontSize: "inherit",
        ...style
      }}
    >
      {children}
    </span>
  );
}